export default "__VITE_ASSET__CYlksbah__"